export default __webpack_public_path__ + "de45c433d54b2c2363bc5af25d80e377.svg";